export const font200 = ["Poppins-ExtraLight", "NotoSans-ExtraLight"].join(",");
export const font300 = ["Poppins-Light", "NotoSans-Light"].join(",");
export const font400 = ["Poppins-Regular", "NotoSans-Regular"].join(",");
export const font500 = ["Poppins-Medium", "NotoSans-Medium"].join(",");
export const font700 = ["Poppins-Bold", "NotoSans-Bold"].join(",");
export const font900 = ["Poppins-Black", "NotoSans-Black"].join(",");
